import React from "react";
import { useForm } from "react-hook-form";

const Contact = () => {
  const [response, setResponse] = React.useState('');
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const encode = (data) => {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key])).join('&');
  }

  const onSubmit = (data, e) => {
    // e.target.reset();
    // console.log("Message submited: " + JSON.stringify(data));
    
    if (document.getElementById("accepted").checked === true) {
      fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: encode({ 'form-name': 'contact', ...data })
      })
        .then(() => {
          console.log('Success!');
          setResponse('Messaggio inviato!');
        })
        .catch(error => {
          console.log(error);
          setResponse('Si è verificato un errore.');
        })
    } else {
      setResponse('Devi accettare la privacy policy per inviare la richiesta!.');
    }    
    
    e.preventDefault();
  };

  return (
    <>
      {/*<form className="contact_form" onSubmit={handleSubmit(onSubmit)} name="contact">*/}
      <form className="contact_form" name="contact" onSubmit={handleSubmit(onSubmit)}>
        <input type="hidden" name="form-name" value="contact" />
        <div className="first_row">
          <input
            {...register("name", { required: true })}
            type="text"
            placeholder="Name *"
            id="name"
            name="name"
          />
          {errors.name && errors.name.type === "required" && (
            <span className="invalid-feedback">Nome richiesto</span>
          )}
        </div>
        {/* End .first_row */}

        <div className="second">
          <input
            {...register(
              "email",
              {
                required: "Email richiesta",
                pattern: {
                  value: /\S+@\S+\.\S+/,
                  message: "Formato email non corretto",
                },
              },
              { required: true }
            )}
            type="email"
            placeholder="Email *"
            id="email"
            name="email"
          />
          {errors.email && (
            <span className="invalid-feedback">{errors.email.message}</span>
          )}
        </div>
        {/* End .second */}

        <div className="third">
          <textarea
            {...register("message", { required: true })}
            placeholder="Message *"
            id="message"
            name="message"
          ></textarea>
          {errors.message && (
            <span className="invalid-feedback">Un messaggio è richiesto</span>
          )}
        </div>
        {/* End .third */}

        <div>
          Privacy Policy - Hai letto la Policy sulla Privacy?
          <br/>
          <input type="radio" id="accepted" name="privacy" value="accepted" style={{width: '20px', height: '20px'}} required/>
          <label for="accepted" className="pl-2">
            letto ed accettata
          </label>
          <br/>
          <input type="radio" id="not_accepted" name="privacy" value="not_accepted" style={{width: '20px', height: '20px'}} required/>
          <label for="not_accepted" className="pl-2">
            letto e non accettata
          </label>
          <br/>
          {errors.message && (
            <span className="invalid-feedback">Un'opzione è richiesta</span>
          )}
        </div>
        {/* End .third */}

        <div className="edina_tm_button">
          <button type="submit" className="color">
            Invia
          </button>
        </div>
        {/* End tokyo_tm_button */}

        <div style={{ marginTop: '90px' }}>
          <span>{response}</span>
        </div>
        {/* End show response */}
      </form>
      {/* End contact */}
    </>
  );
};

export default Contact;
